import { Drawer, Box, List, ListItem, ListItemButton, ListItemText, Slide } from "@mui/material";
import { Turn as Hamburger } from "hamburger-react";
import { MenuItems } from "./Header";
import ReactGA from "react-ga4";
import type { SubMenuItem } from "./Menu";

type MobileMenuProps = {
  menuItems: MenuItems;
  submenu: SubMenuItem[];
  onDrawerToggle: () => void;
  mobileOpen: boolean;
  onAssistantClick?: () => void; // ✅ add this prop
};

const MobileMenu = ({ menuItems, onDrawerToggle, mobileOpen, onAssistantClick }: MobileMenuProps) => {

  const clickHandler = (url: string, title: string) => {
    ReactGA.event({
      category: "Button",
      action: url,
      label: "Bookmark",
    });

    if (title.toLowerCase().includes("assistant") && onAssistantClick) {
      onDrawerToggle(); // ✅ close menu first
      onAssistantClick(); // ✅ trigger scroll
      return;
    }

    if (url.startsWith("http")) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  };

  const drawer = (
    <Box>
      <Box
        sx={{
          height: "76px",
          width: "100%",
          bgcolor: "background.default",
          position: "sticky",
          zIndex: 1,
          top: 0,
        }}
      />

      <List sx={{ px: { xs: 3, sm: 4 }, pt: 2 }}>
        {menuItems.map(({ id, title, url }, i) => {
          if (title === "languageSwitch") return null;
          return (
            <Slide key={id} direction="right" in={mobileOpen} timeout={500} style={{ transitionDelay: `${i * 100}ms` }}>
              <ListItem disablePadding>
                <ListItemButton disableRipple onClick={() => clickHandler(url, title)} divider disableGutters>
                  <ListItemText sx={{ py: 1.5, color: "text.primary" }} primary={title} />
                </ListItemButton>
              </ListItem>
            </Slide>
          );
        })}
      </List>
    </Box>
  );

  return (
    <>
      <Box sx={{ display: { md: "none" }, zIndex: 1300 }}>
        <Hamburger toggled={mobileOpen} toggle={onDrawerToggle} rounded size={28} />
      </Box>

      <Drawer
        variant="persistent"
        open={mobileOpen}
        onClose={onDrawerToggle}
        ModalProps={{
          keepMounted: true,
          BackdropProps: {
            sx: { display: { xs: "block", md: "none" } },
          },
        }}
        transitionDuration={400}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "90%",
            maxWidth: "300px",
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default MobileMenu;
